// noinspection ES6UnusedImports
import Device from      '@core/scripts/components/device';
import Messages from    '@core/scripts/components/messages';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import InputGroup from '@bonprix/pattern-library/templates/input/Group.jsx';
import Option from '@bonprix/pattern-library/templates/input/Option.jsx';
import Select from '@bonprix/pattern-library/templates/input/Select.jsx';
import MiniSlider from '@bonprix/pattern-library/templates/slider/MiniSlider.jsx';
import Slide from '@bonprix/pattern-library/templates/slider/Slide.jsx';
import Toggle from '@bonprix/pattern-library/templates/toggle/default';
import React, { Fragment } from 'react';
import {Typography} from "@bonprix/design-system";

export default function AvailabilityReminderSizeSelection({texts, activeItem, activeItemOptionIndex, sizeSelected}) {
    const DROPDOWN_CUTOFF_LENGTH = 15;

    if (activeItem.itemOptions.length === 1 && activeItem.itemOptions[0].name === '0') {
        // no size choice available
        return;
    }

    const activeItemOption = activeItem.itemOptions[activeItemOptionIndex];
    const currentSizeName = activeItemOptionIndex !== null ? activeItemOption?.name : null;
    const selectedSizeText = currentSizeName !== null && sizeSelected ? currentSizeName : texts.bff_ada_chooseSize;
    const available = sizeSelected
        ? activeItem.itemOptions[activeItemOptionIndex] !== undefined &&
          activeItem.itemOptions[activeItemOptionIndex].availabilityType !== 'soldout'
        : activeItem.itemOptions.some((option) => option.availabilityType !== 'soldout');

    const handleSelectionChange = (itemOptionIdx) => {
        const itemOption = activeItem.itemOptions[itemOptionIdx]
        MessageBroker.publish(Messages.LAYER.CHANGE_ITEM_AVAILABILITY_REMINDER, {
            notifiable: itemOption.availabilityType === 'temp',
            itemOption: itemOption,
            item: activeItem
        });
    };

    const maxSizeLength = Math.max(...activeItem.itemOptions.map((option) => option.name.length));

    const dropdown = (
        <InputGroup
            hasRows // muss gesetzt sein, da sonst ein <label> tag eingef�gt wird, das bei Interaktion mit den options einen Click auf das <input> Element triggert
            testRefs={{'test-ref__product-sizes-select': ''}}
            className="availability-reminder__sizes-inputgroup"
        >
            <Select
                custom
                value={activeItemOption?.id}
                textValue={currentSizeName}
                placeholder={selectedSizeText}
                activeOption={activeItemOption}
            >
                {activeItem.itemOptions.map((itemOption, itemOptionIdx) => {
                    const name = itemOption.name;
                    const isNotAvailable = itemOption.availabilityType === 'soldout';
                    const notifiable = itemOption.availabilityType === 'temp';

                    return (
                        <Option
                            key={itemOptionIdx}
                            custom
                            value={itemOption.id}
                            onClick={() => handleSelectionChange(itemOptionIdx)}
                            icon={notifiable ? 'email' : null}
                            disabled={isNotAvailable}
                            className="wishlist-item__change-item-layer__sizes-option"
                        >
                            {name}
                        </Option>
                    );
                })}
            </Select>
        </InputGroup>
    );

    const slider = (
        <MiniSlider
            className="availability-reminder__slider-selection"
            isTouch={Device.isTouch() || Device.isApp()}
            activeSlideIndex={activeItemOptionIndex === null ? 0 : activeItemOptionIndex}
            beyondEdgeSliding={false}
        >
            {activeItem.itemOptions
                .map((currentItemOption, itemOptionIdx) => {
                    const isNotAvailable = currentItemOption.availabilityType === 'soldout';
                    const notifiable = currentItemOption.availabilityType === 'temp';
                    return (
                        <Slide key={itemOptionIdx}>
                            <Toggle
                                className="availability-reminder__selection-toggle"
                                active={activeItemOptionIndex === itemOptionIdx && sizeSelected}
                                strikeThrough={isNotAvailable}
                                email={notifiable}
                                text={currentItemOption.name}
                                onClick={() => handleSelectionChange(itemOptionIdx)}
                            />
                        </Slide>
                    );
                })
                .filter((value) => value !== undefined)}
        </MiniSlider>
    );

    const availabilityClass = !available ? 'not-available' : '';

    return (
        <Typography variant="body1">
            <div className="availabiltiy-reminder__size-label">
                <div className="availabiltiy-reminder__selection-title">{texts.ada_matrix_groesse}&nbsp;</div>
                <div className="availabiltiy-reminder__selection-name">{maxSizeLength > DROPDOWN_CUTOFF_LENGTH ? '' : selectedSizeText}</div>
            </div>
            {maxSizeLength > DROPDOWN_CUTOFF_LENGTH ? dropdown : slider}
        </Typography>
    );
}
